import { render, staticRenderFns } from "./TabAllotmentComponent.vue?vue&type=template&id=400a95b5&scoped=true"
import script from "./TabAllotmentComponent.vue?vue&type=script&lang=js"
export * from "./TabAllotmentComponent.vue?vue&type=script&lang=js"
import style0 from "./TabAllotmentComponent.vue?vue&type=style&index=0&id=400a95b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400a95b5",
  null
  
)

export default component.exports